export default {
      id: "FunctionHandLeft-usage",
      viewBox: "0 0 54 54",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#FunctionHandLeft",
      toString: function () {
        return this.url;
      }
    }